import { stdObject } from "../../../../data/types/stdObject";

export const createNewPart = (style: stdObject, params: stdObject) => {
  const { docValues, setDocValues } = params;
  const maxNum =
    docValues.parts.length === 0
      ? 1
      : Math.max(
          ...docValues.parts.map(({ NUMPAR }: { NUMPAR: number }) => NUMPAR),
        ) + 1;
  docValues.parts.push({
    ...style,
    CODPAR: docValues.data.CODDOC,
    NUMPAR: maxNum,
  });
  setDocValues({ ...docValues });
  return maxNum;
};
